module.exports = __webpack_public_path__ + "static/media/27.5dc15f33.png";